import { PATHS } from 'src/routes/paths';
import axiosInstance from './axios';
import { jwtDecode } from 'jwt-decode';
import { isEmpty } from './type_check';
import authStore from 'src/stores/auth_store';
import { tokenConfirm } from 'src/components/dialog/confirmation';
import { initializeQzTray } from './qz_tray';
export const TOKEN = 'token';
let expiredTimer;

export const isValidToken = () => {
  var isValid = false;
  const token = getToken();
  if (token) {
    const { exp } = decode(token);
    const currentTime = Date.now() / 1000;
    isValid = exp > currentTime;
  }
  if (!isValid) {
    authStore.getState().logout(false);
  }
  return isValid;
};

export const decode = (token) => {
  if (isEmpty(token)) return {};
  var decodedToken = jwtDecode(token);
  return decodedToken;
};

export const tokenDialog = (exp) => {
  const currentTime = Date.now();

  const timeLeft = exp * 1000 - currentTime - 600000;

  clearTimeout(expiredTimer);

  expiredTimer = setTimeout(async () => {
    await tokenConfirm();
  }, timeLeft);
};

export const deleteToken = () => {
  clearTimeout(expiredTimer);
  if (getToken()) {
    localStorage.removeItem(TOKEN);
    window.location.replace(PATHS.auth.login);
  }
};

export const findToken = async () => {
  var token = getToken();
  setToken(token);
  return token;
};

export const setToken = (token) => {
  if (token) {
    localStorage.setItem(TOKEN, token);
    axiosInstance.defaults.headers.common.Authorization = `Bearer ${token}`;
    initializeQzTray();
    const { exp } = decode(token);
    tokenDialog(exp);
  } else {
    localStorage.removeItem(TOKEN);
    delete axiosInstance.defaults.headers.common.Authorization;
  }
};

export const getTokenRole = () => {
  var token = getToken();
  const { role } = decode(token);
  return role;
};

export const getToken = () => {
  return localStorage.getItem(TOKEN);
};
